
import {
  FIXED_PHONE_PREFIX,
  OTP_WAIT_TIME_IN_SECONDS,
} from "@/constants/constants.constants";
import { adminDropdownChoices } from "@/constants/dropdown-choices.constants";
import { ToastErrors } from "@/constants/generic-errors.enum";
import { changeInfoEmpty } from "@/constants/initial-values.constants";
import { User } from "@/generated-sources/anagrafica-api";
import { CognitoError } from "@/models/error.models";
import { showToast } from "@/services/error-management.service";
import {
  changeProfileInfoSchemaValidation,
  confirmsignupSchemaValidation,
  isChangeInfoFormValid,
} from "@/services/form-validation.service";
import {
  formatItalianPhone,
  mapCognitoError,
  mapInputError,
  uppercase,
} from "@/services/mapping.service";
import { returnNavTooltipChoices } from "@/services/routing.service";
import { ActionTypes } from "@/store/action-types";
import { useStore } from "@/store/store";
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  setup() {
    const store = useStore();
    const formValues = ref({ ...changeInfoEmpty });
    const formErrors = ref({ ...changeInfoEmpty });
    const confirmCodeValue = ref("");
    const confirmCodeError = ref("");
    const formDisabled = ref(true);
    const sendCodeAllowed = ref(true);
    const saveDisabled = ref(true);
    const confirmPhoneModalOpened = ref(false);
    // const cognitoUserInfo = ref(null);
    const dropdownChoices = ref(returnNavTooltipChoices());
    const { t, locale } = useI18n();

    /* COMPUTED */
    const userInfo = computed(function(): User {
      return store.getters.getUser;
    });

    function compareUserToForm(form) {
      let _provv = true;
      Object.entries(form).forEach((val) => {
        if (val[1] !== userInfo.value[val[0]]) {
          _provv = false;
        }
      });
      return _provv;
    }

    watch(formValues.value, function(currentValue, oldValue) {
      saveDisabled.value = compareUserToForm(currentValue);
    });

    function _initializeFormWithValuesFromStore(cell?: string) {
      const user = store.getters.getUser;
      formValues.value.nome = user.nome;
      formValues.value.cognome = user.cognome;
      formValues.value.cell = (cell ?? user.cell).replace("+39", "");
    }

    function initializeErrors() {
      formErrors.value = { ...changeInfoEmpty };
    }

    //AL MOUNTED PREPOPOLA FORM CON VALORI DELL'UTENTE
    onMounted(() => {
      _initializeFormWithValuesFromStore();
    });

    function enableForm() {
      formDisabled.value = false;
    }

    function disableForm() {
      initializeErrors();
      _initializeFormWithValuesFromStore();
      formDisabled.value = true;
    }

    function updateFormValue(value: string, field: string) {
      formValues.value[field] = value;
      console.log("formValues", formValues.value);
    }

    function updateFormError(value: string, field: string) {
      formErrors.value[field] = value;
    }

    function updateCodeValue(value: string) {
      confirmCodeValue.value = value;
    }

    function updateCodeError(value: string) {
      confirmCodeError.value = value;
    }

    function validate(values, field: string) {
      changeProfileInfoSchemaValidation
        .validateAt(field, values)
        .then(() => {
          updateFormError("", field);
        })
        .catch((err) => {
          updateFormError(mapInputError(err.message, t), field);
        });
    }

    function validateCode(value) {
      confirmsignupSchemaValidation
        .validateAt("code", { code: value })
        .then(() => {
          updateCodeError("");
        })
        .catch((err) => {
          updateCodeError(mapInputError(err.message, t));
        });
    }

    function openOTPModal() {
      confirmPhoneModalOpened.value = true;
    }

    function closeOTPModal() {
      confirmPhoneModalOpened.value = false;
    }

    function blockSendCodeForSeconds(seconds: number) {
      if (sendCodeAllowed.value) {
        sendCodeAllowed.value = false;
        setTimeout(() => {
          sendCodeAllowed.value = true;
        }, seconds * 1000);
      }
    }

    function showWaitError() {
      showToast(ToastErrors.WAIT);
    }

    async function sendCode() {
      if (sendCodeAllowed.value) {
        try {
          blockSendCodeForSeconds(OTP_WAIT_TIME_IN_SECONDS);
          await store.dispatch(
            ActionTypes.SEND_SMS_CODE,
            undefined
            // {
            // user: cognitoUserInfo.value,
            // userAttribute: "phone_number",
            // }
          );
        } catch (error) {
          return;
        }
      } else {
        showWaitError();
      }
    }

    async function handlePostConfirmation() {
      try {
        await store.dispatch(ActionTypes.AUTH_ACTION, null);
        // TODO WS3: a cosa serve?!?!?!
        // await store.dispatch(ActionTypes.CURRENT_SESSION, null);
        _initializeFormWithValuesFromStore();
        closeOTPModal();
      } catch (error) {
        return;
      }
    }

    async function confirmPhoneNumber() {
      try {
        await store.dispatch(
          ActionTypes.VERIFY_SMS_CODE,
          confirmCodeValue.value
        );
        await handlePostConfirmation();
      } catch (err) {
        confirmCodeError.value = mapCognitoError(err as CognitoError, t);
      }
    }

    async function sendPhoneNumberAndCode() {
      try {
        // const user = await store.dispatch(
        //   ActionTypes.CURRENT_AUTHENTICATED_USER,
        //   null
        // );
        // cognitoUserInfo.value = user;
        await store.dispatch(ActionTypes.UPDATE_PHONE_NUMBER, {
          id: store.getters.getUser.id,
          phonenumber: formatItalianPhone(formValues.value.cell),
        });
        await sendCode();
      } catch (error) {
        return;
      }
    }

    async function _updateUser() {
      try {
        await store.dispatch(ActionTypes.POST_USER_INFO, {
          id: store.getters.getUser.id,
          user: {
            nome: formValues.value.nome,
            cognome: formValues.value.cognome,
          },
        });
      } catch (error) {
        return;
      }
    }

    function isPhoneChanged() {
      const changed = "+39" + formValues.value.cell !== userInfo.value.cell;
      return changed;
    }

    async function saveProfileChanges() {
      console.log("saveProfileChanges");
      try {
        const cell = formValues.value.cell;
        await _updateUser();
        console.log("initializeFormWithValuesFromStore");
        _initializeFormWithValuesFromStore(cell);
        if (isPhoneChanged()) {
          console.log("sendPhoneNumberAndCode");
          sendPhoneNumberAndCode();
          openOTPModal();
        }
      } catch (err) {
        console.log("err", err);
        return;
      }
    }

    function isButtonDisabled() {
      return !confirmCodeValue.value || confirmCodeError.value;
    }

    return {
      t,
      locale,
      uppercase,
      adminDropdownChoices,
      formValues,
      formErrors,
      userInfo,
      formDisabled,
      enableForm,
      disableForm,
      updateFormValue,
      validate,
      saveDisabled,
      isChangeInfoFormValid,
      saveProfileChanges,
      confirmPhoneModalOpened,
      closeOTPModal,
      confirmCodeValue,
      confirmCodeError,
      updateCodeValue,
      validateCode,
      sendCode,
      isButtonDisabled,
      confirmPhoneNumber,
      dropdownChoices,
      FIXED_PHONE_PREFIX,
    };
  },
});
